export const SHAKE_EXTENSION_PAGE = "https://chromewebstore.google.com/detail/shake/fgpnklngaiahpcpjennhbcmkiahjohdk";
